import { CommonModule } from '@angular/common';
import { Component, inject, input, output, signal } from '@angular/core';

import { TranslationService } from '../../core/i18n/translation.service';
import { MenuItemId } from '../sidebar-menu/sidebar-menu.component';

@Component({
  selector: 'app-submenu',
  imports: [CommonModule],
  templateUrl: './submenu.component.html',
  styleUrl: './submenu.component.css',
})
export class SubmenuComponent {
  protected readonly i18n = inject(TranslationService);

  readonly activeSection = input<MenuItemId>('dashboard');
  readonly createChecklistRequested = output<void>();
  readonly checklistSearchRequested = output<string>();
  readonly createAuditRequested = output<void>();
  readonly auditSearchRequested = output<string>();
  readonly createUserRequested = output<void>();
  readonly userSearchRequested = output<string>();
  readonly issueSearchRequested = output<string>();
  readonly reportIssueRequested = output<void>();

  protected readonly checklistSectionId: MenuItemId = 'checklists';
  protected readonly auditsSectionId: MenuItemId = 'audits';
  protected readonly usersSectionId: MenuItemId = 'users';
  protected readonly reportsSectionId: MenuItemId = 'reports';
  protected readonly dashboardSectionId: MenuItemId = 'dashboard';
  protected readonly correctiveActionsSectionId: MenuItemId = 'corrective-actions';
  protected readonly checklistSearchValue = signal('');
  protected readonly auditSearchValue = signal('');
  protected readonly userSearchValue = signal('');
  protected readonly issueSearchValue = signal('');

  protected createChecklist(): void {
    this.createChecklistRequested.emit();
  }

  protected updateChecklistSearchValue(value: string): void {
    this.checklistSearchValue.set(value);
  }

  protected updateAuditSearchValue(value: string): void {
    this.auditSearchValue.set(value);
  }

  protected submitChecklistSearch(): void {
    this.checklistSearchRequested.emit(this.checklistSearchValue().trim());
  }

  protected submitAuditSearch(): void {
    this.auditSearchRequested.emit(this.auditSearchValue().trim());
  }

  protected createAudit(): void {
    this.createAuditRequested.emit();
  }

  protected updateUserSearchValue(value: string): void {
    this.userSearchValue.set(value);
  }

  protected submitUserSearch(): void {
    this.userSearchRequested.emit(this.userSearchValue().trim());
  }

  protected createUser(): void {
    this.createUserRequested.emit();
  }

  protected updateIssueSearchValue(value: string): void {
    this.issueSearchValue.set(value);
  }

  protected submitIssueSearch(): void {
    this.issueSearchRequested.emit(this.issueSearchValue().trim());
  }

  protected reportIssue(): void {
    this.reportIssueRequested.emit();
  }
}
